// extracted by mini-css-extract-plugin
export default {"UserAccessPage":"CreateUserAccount_UserAccessPage__tnEiL","UserAccessPageCard":"CreateUserAccount_UserAccessPageCard__23rSc","SupStyle":"CreateUserAccount_SupStyle__un6uX"};